/**
 * ¿Hay conexión ahora mismo?
 *
 * La aplicación entera funciona sin red: el curriculum viaja en el bundle y
 * los datos viven en IndexedDB. Lo que NO funciona sin red son las
 * herramientas externas —ChatGPT Voice, YouGlish, Accent Coach— porque son
 * páginas de terceros.
 *
 * Presentarlas como disponibles offline sería mentir, y la mentira se descubre
 * en el peor momento: en mitad de una sesión, tras pulsar «Abrir ChatGPT» y
 * quedarse mirando un error del navegador.
 *
 * `navigator.onLine` solo sabe si hay interfaz de red, no si internet
 * responde. Sirve para el caso que importa —modo avión, sin datos— y no se
 * presenta como más de lo que es: se usa para AVISAR, nunca para bloquear.
 */

import { useEffect, useState } from 'react';

export function useEstaEnLinea(): boolean {
  const [enLinea, setEnLinea] = useState(
    () => typeof navigator === 'undefined' || navigator.onLine !== false,
  );

  useEffect(() => {
    const conectado = () => setEnLinea(true);
    const desconectado = () => setEnLinea(false);
    window.addEventListener('online', conectado);
    window.addEventListener('offline', desconectado);
    // El estado puede haber cambiado entre el primer render y este efecto.
    setEnLinea(navigator.onLine !== false);
    return () => {
      window.removeEventListener('online', conectado);
      window.removeEventListener('offline', desconectado);
    };
  }, []);

  return enLinea;
}

export const AVISO_SIN_CONEXION =
  'Estás sin conexión. La sesión sigue funcionando y todo lo que escribas se guarda, pero esta herramienta es una página externa y necesita internet.';
